export { BoldStrokeSubtitle } from './BoldStrokeSubtitle';
export type { BoldStrokeSubtitleProps } from './BoldStrokeSubtitle';
